var _Text;
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Image, Link, Text } from 'reaxl';
import { footer } from 'axl-config';
import StaticSitemap from '../StaticSitemap';
import FooterLegal from '../StaticFooterLegal';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  sitemap,
  socialIcons,
  appStore
} = footer;
const renderSocialButton = _ref => {
  let {
    alt,
    src,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx(Link, {
    target: "_blank",
    rel: "nofollow noopener",
    ...rest,
    children: /*#__PURE__*/_jsx(Image, {
      src: src,
      alt: alt,
      "aria-hidden": "true",
      lazyload: true,
      width: 24,
      height: 24
    })
  }, rest.href);
};
function StaticFooter(_ref2) {
  let {
    barContent,
    sitemap: footerSitemap = sitemap,
    social: footerSocial = socialIcons,
    appStore: footerAppStore = appStore,
    legal: footerLegal,
    renderThirdParty = true,
    className,
    onClick = () => {},
    enableOneTrustFooter = false,
    ...rest
  } = _ref2;
  return /*#__PURE__*/_jsxs("footer", {
    "data-cmp": "footer",
    className: clsx('footer', className),
    ...rest,
    children: [/*#__PURE__*/_jsx("div", {
      className: "container footer-bar-content display-flex justify-content-end align-items-center",
      children: barContent
    }), /*#__PURE__*/_jsx("div", {
      className: "container-fluid footer-links display-flex justify-content-center",
      children: /*#__PURE__*/_jsxs("div", {
        className: "container footer-links-content display-flex flex-column",
        children: [footerSitemap && /*#__PURE__*/_jsx(StaticSitemap, {
          data: footerSitemap,
          onClick: onClick,
          enableOneTrustFooter: enableOneTrustFooter
        }), /*#__PURE__*/_jsx("div", {
          className: "app-store-bar display-flex justify-content-center margin-bottom-5",
          children: footerAppStore.map((icon, index) => /*#__PURE__*/_jsxs(Link, {
            href: icon.href,
            target: "_blank",
            rel: "nofollow noopener",
            onClick: e => {
              const data = {
                appStoreName: icon.gaAppStoreName
              };
              onClick(e, data);
            },
            children: [/*#__PURE__*/_jsx("span", {
              className: "sr-only",
              children: icon['aria-label']
            }), /*#__PURE__*/_jsx(Image, {
              className: index === 1 ? 'margin-left-4' : '',
              src: icon.src,
              alt: "",
              "aria-hidden": "true",
              lazyload: true,
              height: icon.imgHeight,
              width: icon.imgWidth
            })]
          }, index))
        }), footerSocial && /*#__PURE__*/_jsxs("div", {
          role: "toolbar",
          className: "icon-bar display-flex justify-content-center margin-bottom-5 align-items-center gap-5",
          children: [_Text || (_Text = /*#__PURE__*/_jsx(Text, {
            weight: "bold",
            children: "Follow"
          })), footerSocial.map(renderSocialButton)]
        }), /*#__PURE__*/_jsx(FooterLegal, {
          onClick: onClick
        })]
      })
    })]
  });
}
export default StaticFooter;